<div class="dialog-content-wrapper">
  <div class="unsave-header">
    {{ 'event.send_certificate' | translate }}
  </div>
  <div class="send-certificate-modal m-0" mat-dialog-content>
    <div class="users title">
      <div class="user-name">{{ 'main.frontuser' | translate }}</div>
      <div class="send-logo">{{ 'progress' | translate }}</div>
    </div>
    <div class="users-table">
      @for (user of users; track user) {
        <div class="users">
          <div class="user-name">
            {{ user.frontUser?.firstName }} {{ user.frontUser?.lastName }}
          </div>
          <div class="send-logo" [ngClass]="{'green-logo': user.sent, 'red-logo': user.failed}">
            @if (user.failed) {
              <mat-icon [matTooltip]="'event.certificate_send_failed' | translate">close</mat-icon>
            } @else {
              <mat-icon>done_outline</mat-icon>
            }
          </div>
        </div>
      }
    </div>
  </div>
  <div mat-dialog-actions class="m-0 p-10 unsave-footer" fxLayout="row" fxLayoutAlign="end center">
    @if (!closeButton) {
      <button mat-button (click)="sendCertificates()" [disabled]="blockButton || !users.length">
        <span>{{ 'event.send_certificate' | translate }}</span>
      </button>
    }
    <button mat-button (click)="dialogRef.close()" [disabled]="blockButton">
      <span>{{ 'close' | translate }}</span>
    </button>
  </div>
</div>
<ngx-spinner
  name="sendCertificateComponent"
  [fullScreen]="true"
  [zIndex]="99999"
  bdColor="rgba(0,0,0,0.5)"
  size="medium"
  color="#fff"
  type="line-spin-clockwise-fade">
</ngx-spinner>
